import { render, staticRenderFns } from "./TvaScatterPlot.vue?vue&type=template&id=4792469b&scoped=true&"
import script from "./TvaScatterPlot.vue?vue&type=script&lang=js&"
export * from "./TvaScatterPlot.vue?vue&type=script&lang=js&"
import style0 from "./TvaScatterPlot.vue?vue&type=style&index=0&id=4792469b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792469b",
  null
  
)

export default component.exports